<lib-session-best-block [focal]="focal()" [tiles]="tiles()" />

@if (sessionDrill().shotsCount === null) {
  <sz-card variant="subtle">
    <p class="hf-shots-missing">{{ 'session.hf.shotsCountMissing' | translate }}</p>
  </sz-card>
} @else {
  <sz-section-head
    [label]="(editingRun() ? 'session.hf.editingHeading' : 'session.hf.currentRunHeading') | translate"
    [count]="'session.hf.totalShots' | translate: { count: sessionDrill().shotsCount }" />

  <sz-hf-grid
    [zones]="currentZoneGrid()"
    [time]="currentTimeTile()"
    layout="wrap"
    (zoneClick)="onCellClick($event)"
    (timeClick)="openTimeSheet()" />

  @if (liveHitFactor() !== null) {
    <sz-card>
      <div class="hf-live">
        <div class="hf-live__label">{{ 'session.hf.liveLabel' | translate }}</div>
        <div class="hf-live__value">{{ liveHitFactor() | number: '1.2-2' }}</div>
      </div>
    </sz-card>
  }

  <div class="hf-run-entry__cta-row">
    @if (editingRun() !== null) {
      <sz-button variant="secondary" size="sm" (click)="cancelEdit()">
        {{ 'common.cancel' | translate }}
      </sz-button>
    }
    <sz-button variant="primary" [fullWidth]="true" [disabled]="!canSaveRun()" (click)="saveRun()">
      <sz-icon name="check" [size]="16" />
      {{ (editingRun() ? 'session.hf.updateRunCta' : 'session.numpad.saveRunCta') | translate }}
    </sz-button>
  </div>
}

<sz-section-head
  [label]="'session.runEntry.recentLabel' | translate"
  [count]="'session.runEntry.tapToEdit' | translate" />

<lib-session-rep-list [rows]="rows()" (runEdit)="loadRunForEdit($event)" (runDelete)="deleteRow($event)" />

<lib-numpad-sheet
  [open]="timeSheetOpen()"
  [variant]="timeSheetVariant()"
  [mode]="timeSheetMode()"
  [context]="timeSheetContext()"
  [initialPayload]="timeSheetInitialPayload()"
  [resetTrigger]="timeSheetResetTrigger()"
  (close)="closeTimeSheet()"
  (submitRun)="onTimeSheetSubmit($event)" />
